export default {
    ca: {
        title: 'INSTAMAPS TÉ UN NOU DISSENY! Més actual, més adaptatiu, més usable!',
        message: 'Si teniu cap problema o consideració escriviu-nos a ',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'Enviant el teu email acceptes',
        privacyPoliciesLink: 'la política de privacitat',
    },
    es: {
        title: 'INSTAMAPS TIENE UN NUEVO DISEÑO! Más actual, más adaptativo, más usable!',
        message: 'Si tiene problemas o consideración escríbanos a ',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'Enviando tu email aceptas',
        privacyPoliciesLink: 'la política de privacidad',
    },
    en: {
        title: 'INSTAMAPS HAS A NEW DESIGN! More modern desing, more adaptive, more usable!',
        message: 'If you have any problem or consideration write us to ',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'By sending your email you are accepting the',
        privacyPoliciesLink: 'privacy policies',
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/info-modal/info-modal-translations.js